// eslint-disable-next-line import/prefer-default-export
export const clearLocalStorage = () => localStorage.removeItem('slOnboarding');
